<template>
  <div>
    <b-row v-for="(item,index) in items" :key="index">
      <b-col xl="2" lg="2" md="2" sm="2" xs="2" v-if="page == 'filter'">
        <b-form-group>
          <b-form-select
            class="form-control"
            @change="calldefaultpattern()"
            v-model.trim="item.filter_matching"
            v-validate="'required'"
            data-vv-name="filter matching"
            :name="'filter_matching['+index+']'"
            v-if="index > 0"
          >
            <option value="and">And</option>
            <option value="or">Or</option>
          </b-form-select>
          <input
            type="text"
            v-else
            class="form-control"
            v-model.trim="item.filter_matching"
            v-validate="'required'"
            data-vv-name="filter matching"
            :name="'filter_matching['+index+']'"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col :cols="page == 'filter' ? 2 : 3">
        <b-form-group>
          <b-form-select
            class="form-control"
            v-model.trim="item.columns"
            v-validate="'required'"
            @change="filtermethods(item.columns,index)"
            :name="item.field+'['+index+']'"
            data-vv-name="filter column"
          >
            <option
              v-for="field in custom.fields"
              :key="field.id"
              :value="field.value+','+field.datatype+','+field.category+','+field.custom_id"
            >{{ field.label }}</option>
            <!-- <option
              :value="custom_field.field_name+','+custom_field.datatype + ',custom'"
              v-for="(custom_field,index) in settings.custom_field"
              v-if="custom_field.created == 1 && custom_field.status == 1"
              :key="index"
            >{{ custom_field.label_name }}</option>-->
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col xl="3" lg="3" md="3" sm="3" xs="3">
        <template v-if="item.columns !=''">
          <b-form-group>
            <b-form-select
              class="form-control"
              v-model.trim="item.comparator"
              v-validate="'required'"
              :name="'type['+index+']'"
              data-vv-name="filter comparision"
            >
              <option
                value="1"
                v-if="item.type=='text' || item.type=='textarea' || item.type=='number' || item.type =='checkbox' || item.type =='radio'  || item.type=='url' || item.type=='phone' || item.type=='amount' || item.type=='decimal'  || item.type=='date' || item.type=='select'||item.type=='email'||item.type=='percent'"
              >Is</option>
              <option
                value="2"
                v-if="item.type=='text' || item.type=='textarea' || item.type=='number'   || item.type =='radio' || item.type=='url' || item.type=='phone' || item.type=='amount' || item.type=='decimal'  || item.type=='date' || item.type=='select'||item.type=='email'||item.type=='percent'"
              >Is Not</option>
              <option
                value="3"
                v-if="item.type=='amount' || item.type=='decimal'  || item.type=='date'||item.type=='percent'"
              >Greater than</option>
              <option
                value="4"
                v-if="item.type=='amount' || item.type=='decimal'  || item.type=='date'||item.type=='percent'"
              >Less than</option>
              <option
                value="5"
                v-if="item.type=='text' || item.type=='textarea' || item.type=='number'||item.type=='email' "
              >Starts with</option>
              <option
                value="6"
                v-if="item.type=='text' || item.type=='textarea' || item.type=='number' "
              >Ends with</option>
              <option
                value="7"
                v-if="item.type=='text' || item.type=='textarea' || item.type=='number'  || item.type=='date' || item.type=='phone'||item.type=='email'"
              >Contains</option>
              <option
                value="8"
                v-if="item.type=='text' || item.type=='textarea' || item.type=='number'  || item.type=='date' || item.type=='phone'||item.type=='email'"
              >Does not contains</option>
              <option value="10" v-if="item.type=='multiselect' ||  item.type=='pdt_ids'">In</option>
              <option value="11" v-if="item.type=='multiselect' ||  item.type=='pdt_ids'">Not In</option>
              <option
                value="12"
                v-if="item.type=='amount' || item.type=='decimal'  || item.type=='date'||item.type=='percent'"
              >Greater than or equal to</option>
              <option
                value="13"
                v-if="item.type=='amount' || item.type=='decimal'  || item.type=='date'||item.type=='percent'"
              >Less than or equal to</option>
            </b-form-select>
          </b-form-group>
        </template>
      </b-col>

      <b-col xl="4" lg="4" md="4" sm="4" xs="4">
        <template v-if="item.comparator !=''">
          <!-- Start of values field -->

          <b-form-group>
            <!-- <template
            v-for="custom_field in settings.custom_field"
            v-if="custom_field.created == 1 &&  custom_field.status == 1 &&item.field==custom_field.field_name"
          >
            <CustomPreview
              :key="custom_field.id"
              v-on:assigncustomvalue="items[index].value = $event.value"
              :custom="custom_field"
              :disabled="false"
              :modelname="item.value"
            />
            <input
              data-vv-name="filter value"
              :key="custom_field.id"
              type="hidden"
              class="form-control"
              v-model.trim="item.value"
              v-validate="'required'"
              :name="'value['+index+']'"
            />
            </template>-->
            <div v-if="item.cat != 'custom'">
              <DatePicker
                data-vv-name="filter value"
                @input="selectDate($event,index)"
                :format="$AppDetails.organization.date_format"
                v-if="item.type=='date'"
                style="width:100% !important;"
                lang="en"
                :name="'value['+index+']'"
                v-model="item.value"
                v-validate="'required'"
              >
                <i class="fa fa-calendar" slot="calendar-icon" />
              </DatePicker>
              <v-select
                :clearable="false"
                v-if="item.field == 'cus_id' || item.field == 'vdr_id' || item.field == 'pdt_ids'"
                @change="item.value = item.options.value,item.arrayvalues=[]"
                v-model.trim="item.options"
                :filterable="false"
                :options="item.arrayvalues"
                @search="onSearch($event,item)"
              >
                <template slot="no-options">{{ item.generatemessage }}</template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">{{ option.label }}</div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">{{ option.label }}</div>
                </template>
              </v-select>

              <v-select
                :clearable="false"
                v-if="(
                (item.type == 'select' && item.field != 'cus_id' && item.field != 'vdr_id' && item.field != 'pdt_ids') || 
                (item.type == 'multiselect' && item.field != 'pdt_ids')
                ) && (item.field != 'place_of_supply' && item.field != 'source_of_supply')|| (item.type == 'checkbox')"
                label="label"
                index="value"
                :name="'value['+index+']'"
                v-validate="'required'"
                data-vv-name="filter value"
                v-model.trim="item.value"
                :options="
                item.category == 'custom' && item.type != 'checkbox'
                  ? list.custom_option_list[item.field]
                  : item.type == 'checkbox'?checkbox_option_list: list[item.field]
              "
                placeholder="Choose"
              ></v-select>
              <v-select
                :clearable="false"
                v-else-if="item.field == 'place_of_supply' || item.field == 'source_of_supply'"
                label="label"
                index="value"
                :name="'value['+index+']'"
                v-validate="'required'"
                data-vv-name="filter value"
                v-model.trim="item.value"
                :options="$AppDetails.state_list.map(StateList => ({label:StateList.state_name, value: StateList.state_id}))"
                placeholder="Choose"
              ></v-select>

              <input
                data-vv-name="filter value"
                type="text"
                class="form-control"
                v-model.trim="item.value"
                v-if="item.type=='text' || item.type=='amount' || item.type=='decimal' || item.type=='number' || item.type=='phone' || item.type=='url'||item.type=='email'||item.type=='percent'"
                v-validate="'required'"
                :name="'value['+index+']'"
              />
              <b-form-textarea
                data-vv-name="filter value"
                v-if="item.type == 'textarea'"
                v-model="item.value"
                :name="'value['+index+']'"
              ></b-form-textarea>
            </div>
          </b-form-group>
        </template>
      </b-col>
      <b-col xl="1" lg="1" md="1" sm="1" xs="1">
        <!-- Remove row -->
        <b-form-group class="adv_del">
          <span>
            <i class="glyphicon glyphicon-trash" @click="removeRow(index)"></i>
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <!-- Add new row -->
      <b-col xl="12" md="12" lg="12" sm="12" xs="12">
        <span
          :class="items.length<10?'text-link':'text-muted'"
          @click="addNewRow()"
          style="cursor:pointer"
        >
          Add Customize search
          <i
            v-if="items.length>=10"
            class="fa fa-exclamation-triangle pl-2 text-warning fa-md"
            v-b-tooltip
            title="Filter conditions must be within ten criteria"
          ></i>
        </span>
      </b-col>
    </b-row>
    <br />
    <div
      class="p-3"
      style="background:#f9fbfd"
      v-if="items.length > 1 && $route.meta.action != 'index'"
    >
      <strong class="mr-2">Criteria Pattern:</strong>
      <span
        style="cursor:pointer"
        v-if="!showpatternedit"
        class="mr-2"
        @click="showpatternedit=!showpatternedit"
      >{{pattern}}</span>
      <textarea
        v-else
        @blur="isvalidpattern()"
        v-model.trim="pattern"
        class="form-control"
        :class="{'is-invalid':patternwrong}"
        style="width:500px"
        data-vv-name="Pattern"
        name="pattern"
        v-validate="'required'"
      ></textarea>

      <span
        v-html="pattern_content"
        :class="{'text-danger':patternwrong,'text-success':!patternwrong}"
      ></span>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import { mapState } from "vuex";
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import DatePicker from "vue2-datepicker"; // vue datepicker
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import _ from "lodash";
import $ from "jquery";
export default {
  mixins: [formatDate],
  props: ["custom", "settings", "items", "page", "filter_pattern"],
  components: { CustomPreview, vSelect, DatePicker },
  inject: ["$validator"],
  data() {
    return {
      pattern: this.filter_pattern,
      showpatternedit: false,
      patternwrong: false,
      pattern_content: "",
      checkbox_option_list: [
        {
          value: "0",
          label: "False"
        },
        {
          value: "1",
          label: "True"
        }
      ]
    };
  },

  methods: {
    calldefaultpattern() {
      var open_pr = [];
      var close_pr = [];
      var items = this.items.length;
      // get the default paranthesis for the pattern
      for (var i = 0; i < items; i++) {
        var filter_match = this.items[i + 1]
          ? this.items[i + 1].filter_matching
          : "";
        open_pr.push("(");
        close_pr.push(i + 1 + " ) " + filter_match + " ");
      }
      this.pattern = open_pr.join("") + close_pr.join("");
    },
    isvalidpattern() {
      this.patternwrong = false;
      this.showpatternedit = false;
      this.pattern_content = "Your pattern saved successfully";

      var i = 0;
      //   <!----------------start--------------->
      var checkforempty = this.pattern;

      checkforempty = checkforempty.replace(/and|or/gi, x => {
        if (x == "and" || x == "or") {
          return "";
        }
      }); // remove and or from the given string
      checkforempty = checkforempty.replace(/[()]/g, ""); // remove the paranthesis from the string
      checkforempty = checkforempty.replace(/[0-9]/g, ""); // remove the numeric characters from the string
      if ($.trim(checkforempty) != "") {
        this.pattern_content = "Invalid value passed for the crietria";
        this.patternwrong = true;
        this.showpatternedit = true;
        return false;
      }
      //  <!----------------end--------------->
      //    step 2: matching brackets
      //   <!----------------start--------------->
      let stack = []; // declare the stack
      var getbrackets = this.pattern; // splice the 'and','or' and numeric characters for validation matching brackets
      getbrackets = getbrackets.replace(/and|or/gi, x => {
        if (x == "and" || x == "or") {
          return "";
        }
      });
      getbrackets = getbrackets.replace(/[0-9]/g, "");
      // loop the brackets for validation
      for (i = 0; i < getbrackets.length; i++) {
        var bracket = $.trim(getbrackets[i]);
        if (bracket != "") {
          if (bracket == "(") {
            stack.push(bracket);
          } else {
            if (stack.length == 0) {
              this.pattern_content = "Pattern brackets do not match";
              this.patternwrong = true;
              this.showpatternedit = true;
              return false;
            }
            stack.pop();
          }
        }
      }
      if (stack.length !== 0) {
        this.pattern_content = "Pattern brackets do not match";
        this.patternwrong = true;
        this.showpatternedit = true;
        return false;
      }
      //  <!----------------end--------------->

      //    step 3: splice paranthesis and validate remaining
      //   <!----------------start--------------->
      var ratherparanthesis = this.pattern; //splice the '()' for validating remaining criteria
      ratherparanthesis = ratherparanthesis.replace(/[()]/g, " ");
      var andregEx = new RegExp("and", "ig");
      var orregEx = new RegExp("or", "ig");
      ratherparanthesis = $.trim(ratherparanthesis.replace(/ /g, ""));
      ratherparanthesis = ratherparanthesis.replace(andregEx, " and ");
      ratherparanthesis = ratherparanthesis.replace(orregEx, " or ");

      ratherparanthesis = ratherparanthesis.split(" ");

      var countstart = 1;
      ratherparanthesis.map((val, key) => {
        if (val) {
          if (!isNaN(val)) {
            if (val == countstart) {
              countstart++; // check numeric order is correct or not
            } else {
              this.pattern_content = "Invalid order passed for criteria";
              this.patternwrong = true;
              this.showpatternedit = true;
              return false;
            }
          }
          if (key == ratherparanthesis.length - 1) {
            if (isNaN(val)) {
              this.pattern_content = "Invalid order passed for criteria";
              this.patternwrong = true;
              this.showpatternedit = true;
              return false;
            }
          }
          if (countstart == 1 && (val == "and" || val == "or")) {
            this.pattern_content = "Invalid pattern";
            this.patternwrong = true;
            this.showpatternedit = true;
            return false;
          }
        }
        if (val == "and" || val == "or") {
          if (this.items[countstart - 1]) {
            this.items[countstart - 1].filter_matching = val;
          } else {
            this.pattern_content = "Invalid order passed for criteria";
            this.patternwrong = true;
            this.showpatternedit = true;
          }
        }
        var nextloop = key + 1;
        if (nextloop <= ratherparanthesis.length - 1) {
          if (
            val &&
            !isNaN(val) &&
            ratherparanthesis[nextloop] &&
            !isNaN(ratherparanthesis[nextloop])
          ) {
            this.pattern_content = "Invalid order passed for criteria";
            this.patternwrong = true;
            this.showpatternedit = true;
            return false;
          }
        }
      });
      if (countstart - 1 !== this.items.length) {
        this.pattern_content = "Invalid order passed for criteria";
        this.patternwrong = true;
        this.showpatternedit = true;
        return false;
      }
      //  <!----------------end--------------->
      //    step 4: group all the string and check brackets mismatching between the formula
      //   <!----------------start--------------->
      var groupall = $.trim(this.pattern); //splice the '()' for validating remaining criteria
      groupall = groupall.replace(/\s/g, "");

      var tot = groupall.length;
      for (i = 0; i < tot; i++) {
        if (i !== tot - 1) {
          var log =
            groupall[i + 1] == "a" ? "and" : groupall[i + 1] == "o" ? "or" : "";
          if (
            (groupall[i] == "(" && groupall[i + 1] == ")") ||
            (log == "and" && groupall[i + 4] == ")") ||
            (log == "or" && groupall[i + 3] == ")")
          ) {
            this.pattern_content = "Invalid pattern";
            this.patternwrong = true;
            this.showpatternedit = false;
            return false;
          }
          if (groupall[i] == "a") {
            i += 2;
          } else if (groupall[i] == "o") {
            i += 1;
          }
        }
      }
      //  <!----------------end--------------->
    },
    updatefilterpattern() {
      if (this.$route.params.id) {
        this.pattern = JSON.parse(JSON.stringify(this.filter_pattern));
      }
    },
    async onSearch($event, item) {
      //   loading(true);
      item.generatemessage = "Loading...";
      await this.search(item, $event, this);
    },
    search: _.debounce((item, search, vm) => {
      var data =
        item.autoselect == "fetchCustomerData" ||
        item.autoselect == "fetchVendorData"
          ? escape(search)
          : JSON.stringify({ field: escape(search), type: "filter" });
      vm.$store.dispatch("general/" + item.autoselect, data).then(res => {
        if (res.length == 0) {
          item.generatemessage = "No results found";
          item.arrayvalues = [];
        } else {
          item.arrayvalues = res;
        }
      });
    }, 350),
    filtermethods(val, index) {
      if (val != "") {
        var category = val.split(",");
        this.items[index].field = category[0];
        this.items[index].type = category[1];
        this.items[index].category =
          category[2] != "undefined" ? category[2] : "";
        this.items[index].custom_id =
          category[3] != "undefined" ? category[3] : "";
        this.items[index].value = "";
        if (
          category[0] == "cus_id" ||
          category[0] == "vdr_id" ||
          category[0] == "pdt_ids"
        ) {
          this.items[index].options = [];
          this.items[index].generatemessage = "Type to search";
          this.items[index].autoselect =
            category[0] == "cus_id"
              ? "fetchCustomerData"
              : category[0] == "vdr_id"
              ? "fetchVendorData"
              : "fetchProductData";
        }
        // if (category[2]) {
        //   EventBus.$emit("updatecustommodelvalue");
        // }
      }
    },
    //add row
    addNewRow() {
      if (this.items.length < 10) {
        this.items.push({
          type: "text",
          generatemessage: "Type to search",
          arrayvalues: [],
          options: [],
          autoselect: "",
          filter_matching: "and",
          field: "",
          columns: "",
          cat: "",
          comparator: "",
          value: ""
        });

        this.items[0].filter_matching = "When";
        this.calldefaultpattern();
      }
    },
    selectDate(val, index) {
      var value =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
      this.items[index].value = value;
    },
    removeRow(index) {
      if ((this.page == "filter" && this.items.length > 1) || !this.page) {
        this.items.splice(index, 1);
      }
      this.items[0].filter_matching = "When";
      this.calldefaultpattern();
    },
    validatefilter() {
      this.$validator.validateAll().then(result => {
        if (this.patternwrong == false) {
          this.$emit("submit", {
            result: result,
            pattern: this.pattern,
            pattern_array: this.pattern_array
          });
        }
      });
    }
  },

  mounted() {
    if (!this.$route.params.id) {
      this.calldefaultpattern();
    }
    EventBus.$on("validatefilter", this.validatefilter); // to trigger the method from parentcomponent
  },
  //computed
  computed: {
    pattern_array() {
      var pattern_array = [];
      //    step 5: assign the patter to each items
      //   <!----------------start--------------->
      var patterassign = $.trim(this.pattern); //splice the '()' for validating remaining criteria
      patterassign = patterassign.replace(/\s/g, "");
      patterassign = patterassign.replace(/\d+/g, "|");
      patterassign = patterassign.split("|");

      patterassign.map(val => {
        pattern_array.push(val);
      });
      //  <!----------------end--------------->
      return pattern_array;
    },
    ...mapState({
      list: state => state.general.filterdetails
    })
  }
};
</script>